<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" :tid="threeID" :fid="fourID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <p class="add-title">添加现代文阅读</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="write-txt">
          <p class="write-title"><span>*</span>省市：</p>
          <div class="write-text">
            <el-cascader
              v-model="cityValue"
              :options="cityData"
              @change="handleChange"></el-cascader>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title"><span>*</span>学段：</p>
          <div class="write-text">
            <el-select placeholder="请选择" v-model="addObj.period">
              <el-option
                v-for="item in educationList"
                :key="item.id"
                :label="item.title"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title"><span>*</span>文章内容：</p>
          <div class="write-text">
            <textarea placeholder="请输入文章内容" v-model="addObj.content"></textarea>
          </div>
        </div>

        

        <div class="write-txt write-ai">
          <p class="write-title"><span>*</span>文章一级标签：{{addObj.material_label_one}}</p>
          <button class="btn btn-ai" @click="aiSub('article',1)">{{addObj.material_label_one?'重新识别':'点击进行AI识别'}}</button>
          <span class="ai-msg">AI识别后可手动修改</span>
          <div class="write-text">
            <el-select placeholder="请选择" v-model="value1" @change="articleLabel('1',$event)">
              <el-option
                v-for="item in articleOneList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="write-txt write-ai">
          <p class="write-title">文章二级标签：{{addObj.material_label_two}}</p>
          <button class="btn btn-ai" @click="aiSub('article',2)">{{addObj.material_label_two?'重新识别':'点击进行AI识别'}}</button>
          <span class="ai-msg">AI识别后可手动修改</span>
          <div class="write-text">
            <el-select  placeholder="请选择" v-model="value2" @change="articleLabel('2',$event)">
              <el-option
                v-for="item in articleTwoList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="write-txt write-ai">
          <p class="write-title">文章三级标签：{{addObj.material_label_three}}</p>
          <button class="btn btn-ai" @click="aiSub('article',3)">{{addObj.material_label_three?'重新识别':'点击进行AI识别'}}</button>
          <span class="ai-msg">AI识别后可手动修改</span>
          <div class="write-text">
            <el-select  placeholder="请选择" v-model="value3" @change="articleLabel('3',$event)">
              <el-option
                v-for="item in articleThreeList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        
        <div class="topicList">
          <div class="topic-item" v-for="(item,index) in addObj.topic" :key="index">
            <div class="topic-title">
              题目{{(index+1)}}
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>题干：</p>
              <div class="write-text">
                <textarea placeholder="清输入题干" v-model="item.topic"></textarea>
              </div>
            </div>

            <div class="write-txt write-ai">
              <p class="write-title"><span>*</span>题干一级标签：{{item.topic_label_one}}</p>
              <button class="btn btn-ai" @click="aiSub('topic',1,item)">{{item.topic_label_one?'重新识别':'点击进行AI识别'}}</button>
              <span class="ai-msg">AI识别后可手动修改</span>
              <div class="write-text">
                <el-select  placeholder="请选择" v-model="topicValue1" @change="articleLabel('1',$event,'topic',index)">
                  <el-option
                    v-for="item in topicOneList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="write-txt write-ai">
              <p class="write-title">题干二级标签：{{item.topic_label_two}}</p>
              <button class="btn btn-ai" @click="aiSub('topic',2,item)">{{item.topic_label_two?'重新识别':'点击进行AI识别'}}</button>
              <span class="ai-msg">AI识别后可手动修改</span>
              <div class="write-text">
                <el-select  placeholder="请选择" v-model="topicValue2" @change="articleLabel('2',$event,'topic',index)">
                  <el-option
                    v-for="item in topicTwoList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="write-txt write-ai">
              <p class="write-title">题干三级标签：{{item.topic_label_three}}</p>
              <button class="btn btn-ai" @click="aiSub('topic',3,item)">{{item.topic_label_three?'重新识别':'点击进行AI识别'}}</button>
              <span class="ai-msg">AI识别后可手动修改</span>
              <div class="write-text">
                <el-select  placeholder="请选择" v-model="topicValue3" @change="articleLabel('3',$event,'topic',index)">
                  <el-option
                    v-for="item in topicThreeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="write-txt write-ai">
              <p class="write-title">题型：</p>
              <div class="write-text">
                <input type="text" v-model="item.topic_type">
              </div>
              <button class="btn btn-ai" @click="aiSub('topicType',0,item)">{{item.topic_type?'重新识别':'点击进行AI识别'}}</button>
              <span class="ai-msg">AI识别后可手动修改</span>
            </div>

            <div class="write-txt">
              <p class="write-title"><span>*</span>答案：</p>
              <div class="write-text">
                <textarea placeholder="请输入答案" v-model="item.answer"></textarea>
              </div>
            </div>
          </div>
          <button class="btn btn-topic-add" @click="addTopic">+添加题目</button>
        </div>

        <div class="write-txt">
          <p class="write-title"><span>*</span>解题步骤：</p>
          <div class="write-text">
            <textarea placeholder="请输入解题步骤" v-model="addObj.explain"></textarea>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加现代文阅读</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>文章/题干:</p>
              <input type="text" placeholder="请输入要搜索的文章/题干" v-model="obj.title">
            </div>
            <div class="search-item">
              <p>文章一级标签:</p>
              <el-select v-model="obj.material_label_one" filterable placeholder="请选择">
                <el-option
                  v-for="item in labelList1"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>题干一级标签:</p>
              <el-select v-model="obj.topic_label_one" filterable placeholder="请选择">
                <el-option
                  v-for="item in labelList2"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title">
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">现代文阅读列表<p>列表中多次出现同一个文章时，则代表该文章存在多个题干</p></div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.content">{{item.content}}</p>
              <p :title="item.material_label_one">{{item.material_label_one}}</p>
              <p :title="item.material_label_two">{{item.material_label_two}}</p>
              <p :title="item.material_label_three">{{item.material_label_three}}</p>
              <p :title="item.topic">{{item.topic}}</p>
              <p :title="item.topic_label_one">{{item.topic_label_one}}</p>
              <p :title="item.topic_label_two">{{item.topic_label_two}}</p>
              <p :title="item.topic_label_three">{{item.topic_label_three}}</p>
              <p :title="item.answer">{{item.answer}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)">删除</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTopicList ,getAiRecognition ,getTypeLabelList ,saveTopic ,getTopicDetail ,delTopic} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import cityJson from './../assets/json/city.json'
export default {
  name: "index",
  data() {
    return {
      navId:'1',
      childrenID:'1-1',
      threeID:'1-1-1',
      fourID:'1-1-1-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'文章'},
        {id:3,title:'文章一级标签'},
        {id:4,title:'文章二级标签'},
        {id:5,title:'文章三级标签'},
        {id:6,title:'题干'},
        {id:7,title:'题干一级标签'},
        {id:8,title:'题干二级标签'},
        {id:9,title:'题干三级标签'},
        {id:10,title:'答案'},
        {id:11,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        province:'',
        city:'',
        period:'',
        content:'',
        explain:'',
        material_label_one:'',
        material_label_two:'',
        material_label_three:'',
        topic:[
          {
            topic:'',
            topic_type:'',
            answer:'',
            topic_label_one:'',
            topic_label_two:'',
            topic_label_three:'',
          }
        ]
      },
      totalPage:0,
      removeID:'',
      url:'',
      educationList:[
        {id:1,title:'小学',value:'1'},
        {id:2,title:'初中',value:'2'},
        {id:3,title:'高中',value:'3'},
      ],
      statusList:[
        {id:1,title:'已开启',value:1},
        {id:2,title:'已隐藏',value:0},
        {id:3,title:'未选择',value:9},
      ],
      cityData:[],
      sortList:[
        {id:1,title:'已开启',value:1},
        {id:2,title:'已隐藏',value:0},
        {id:3,title:'未选择',value:9},
      ],
      cityValue:[],
      value1:'',
      value2:'',
      value3:'',
      articleOneList:[],
      articleTwoList:[],
      articleThreeList:[],
      topicOneList:[],
      topicTwoList:[],
      topicThreeList:[],
      topicValue1:'',
      topicValue2:'',
      topicValue3:'',
      loading:false,
      loadTxt:'',
      labelList1:[],
      labelList2:[]
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
    var list = [];
    cityJson.forEach(function(item,index){
      item.children.forEach(function(ele,num){
        delete ele.children;
      })
    })
    this.cityData = cityJson;
  },
  methods: {
    handleChange() {
      var that = this;
      this.cityData.forEach(function(item,index){
        if(item.value == that.cityValue[0]){
          that.addObj.province = item.label;
        }
        item.children.forEach(function(ele,num){
          if(ele.value == that.cityValue[1]){
            that.addObj.city = ele.label;
          }
        })
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getTopicList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getTypeLabelList({type:1,table_type:1},this.token);
        if(response.code == 200){
          that.labelList1 = response.data;
          that.articleOneList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getTypeLabelList({type:1,table_type:2},this.token);
        if(response.code == 200){
          that.labelList2 = response.data;
          that.topicOneList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getTopicDetail({tmid:e.tmid},this.token);
        if(response.code == 200){
          that.cityValue = [];
          that.addType = 'edit';
          response.data.period = JSON.stringify(response.data.period)
          that.addObj = response.data;
          that.cityData.forEach(function(item,index){
            if(item.label == response.data.province){
              that.cityValue.push(item.value);
            }
            item.children.forEach(function(ele,num){
              if(ele.label == response.data.city){
                that.cityValue.push(ele.value);
              }
            })
          });
          that.articleOneList.forEach(function(item,index){
            if(item.title == that.addObj.material_label_one){
              that.value1 = item.id;
            }
          });
          
          
          that.topicOneList.forEach(function(item,index){
            if(item.title == that.addObj.topic_label_one){
              that.topicValue1 = item.id;
            }
          })
          
         
          // that.getLabelDetail(2,'article');
          // that.getLabelDetail(2,'topic');
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    async getLabelDetail(i,type){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:that.value1,
          table_type:1
        };
        if(type == 'topic'){
          obj.one_id = this.topicValue1;
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:this.value2,
          table_type:1
        }
        if(type == 'topic'){
          obj.two_id = that.topicValue2;
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
              that.articleTwoList.forEach(function(item,index){
                if(item.title == that.addObj.material_label_two){
                  that.value2 = item.id;
                }
              })
              that.getLabelDetail(3,'article');
            } else {
              that.topicTwoList = response.data;
              that.topicTwoList.forEach(function(item,index){
                if(item.title == that.addObj.topic_label_two){
                  that.topicValue2 = item.id;
                }
              })
              that.getLabelDetail(3,'topic');
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
              that.articleThreeList.forEach(function(item,index){
                if(item.title == that.addObj.material_label_three){
                  that.value3 = item.id;
                }
              })
            } else {
              that.topicThreeList = response.data;
              that.topicThreeList.forEach(function(item,index){
                if(item.title == that.addObj.topic_label_three){
                  that.topicValue3 = item.id;
                }
              })
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      this.removeID = e.tmid;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delTopic({tmid:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.province == ''){
        that.$message('请选择省！');
        return false;
      }
      if(this.addObj.city == ''){
        that.$message('请选择市！');
        return false;
      }
      if(this.addObj.period == ''){
        that.$message('请选择学段！');
        return false;
      }
      if(this.addObj.content == ''){
        that.$message('请填写文章内容！');
        return false;
      }
      if(this.addObj.explain == ''){
        that.$message('请填写解题步骤！');
        return false;
      }
      if(this.addObj.material_label_one == '' || this.addObj.material_label_one == '生成中...'){
        that.$message('请选择文章一级标签！');
        return false;
      }
      try {
          that.addObj.topic.forEach(function(item,index){
            if(item.topic == ''){
                that.$message('题目'+(index+1)+'题干还未填写');
                throw new Error("EndIterative");
            } 
            if(item.answer == ''){
                that.$message('题目'+(index+1)+'答案还未填写');
                throw new Error("EndIterative");
            } 
            if(item.topic_label_one == '' || item.topic_label_one == '生成中...'){
                that.$message('题目'+(index+1)+'题干一级标签还未填写');
                throw new Error("EndIterative");
            } 
          })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      try {
        const response = await saveTopic(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.cityValue = '';
      this.addObj = {
        province:'',
        city:'',
        period:'',
        explain:'',
        content:'',
        material_label_one:'',
        material_label_two:'',
        material_label_three:'',
        topic:[
          {
            topic:'',
            topic_type:'',
            answer:'',
            topic_label_one:'',
            topic_label_two:'',
            topic_label_three:'',
          }
        ]
      };
      this.value1 = '';
      this.value2='';
      this.value3='';
      this.topicValue1='';
      this.topicValue2='';
      this.topicValue3='';
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.getList();
      } else {
        that.$message(response.msg);
      };
      that.loading = false;
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj={
        province:'',
        city:'',
        period:'',
        content:'',
        explain:'',
        material_label_one:'',
        material_label_two:'',
        material_label_three:'',
        topic:[
          {
            topic:'',
            topic_type:'',
            answer:'',
            topic_label_one:'',
            topic_label_two:'',
            topic_label_three:'',
          }
        ]
      };
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    async aiSub(type,i,e){
      var that = this;
      var obj = {};
      if(this.addObj.content == ''){
        that.$message('请填写文章内容！');
        return false;
      }
      if(type=='article'){
        obj = {
          type:1,
          level:i,
          content:this.addObj.content,
        };
        if(i == 2){
          that.addObj.material_label_two = '生成中...'
          obj.material_label_one = that.addObj.material_label_one ? that.addObj.material_label_one : this.value1
        }
        if(i == 3){
          that.addObj.material_label_three = '生成中...'
          obj.material_label_two = that.addObj.material_label_two ? that.addObj.material_label_two : this.value2
        }
        if(i == 1){
          that.addObj.material_label_one = '生成中...'
          that.getTypeList(i,'article')
        }

      } else if(type == 'topic'){
        try {
          that.addObj.topic.forEach(function(item,index){
            if(item.topic == ''){
                that.$message('题目'+(index+1)+'题干还未填写');
                throw new Error("EndIterative");
            } else {
                // console.log(ele,num);
            }
          })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
        obj = {
          type:2,
          level:i,
          content:this.addObj.content,
          topic:e.topic
        };
        if(i == 2){
          e.topic_label_two = '生成中...'
          obj.topic_label_one = e.topic_label_one ? e.topic_label_one : this.topicValue1;
        }
        if(i == 3){
          e.topic_label_three = '生成中...'
          obj.topic_label_two = e.topic_label_two ? e.topic_label_two : this.topicValue2;
        }
        if(i == 1){
          e.topic_label_one = '生成中...'
          that.getTypeList(i,'topic')
        }
      } else if(type == 'topicType'){
        obj = {
          type:3,
          topic:e.topic,
        }
        e.topic_type = '生成中...'
      };
      this.loading = true;
      this.loadTxt = '请稍后...'
      try {
        const response = await getAiRecognition(obj,this.token);
        if(response.code == 200){
          if(type == 'article'){
            if(i == 1){
              that.addObj.material_label_one = response.data.answer;
              that.value1 = '';
            } else if(i == 2){
              that.addObj.material_label_two = response.data.answer;
              that.value2 = '';
            } else if(i == 3){
              that.addObj.material_label_three = response.data.answer;
              that.value3 = '';
            } 
          } else if(type == 'topic'){
            if(i == 1){
              e.topic_label_one = response.data.answer;
              that.topicValue1 = '';
            } else if(i == 2){
              e.topic_label_two = response.data.answer;
              that.topicValue2 = '';
            } else if(i == 3){
              e.topic_label_three = response.data.answer;
              that.topicValue3 = '';
            } 
          } else if(type == 'topicType'){
            e.topic_type = response.data.answer;
          };
          that.$forceUpdate();
          that.loading = false;
        } else {
          that.loading = false;
          that.$message(response.msg);
        }
      } catch (error) {
        that.loading = false;
        that.$message(error);
      }
    },

    async getTypeList(i,type){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:that.value1,
          table_type:1
        };
        if(type == 'topic'){
          obj.one_id = this.topicValue1;
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:this.value2,
          table_type:1
        }
        if(type == 'topic'){
          obj.two_id = that.topicValue2;
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 1){
            if(type == 'article'){
              that.articleOneList = response.data;
            } else {
              that.topicOneList = response.data;
            }
          }
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
            } else {
              that.topicTwoList = response.data;
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
            } else {
              that.topicThreeList = response.data;
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    articleLabel(type,e,topic,num){
      var that = this;
      if(type == 1){
        if(topic == 'topic'){
          that.getTypeList(2,'topic');
          that.topicOneList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_one = item.title
            }
          });
          that.addObj.topic[num].topic_label_two = '';
          that.topicValue2 = '';
          that.addObj.topic[num].topic_label_three = '';
          that.topicValue3 = '';
        } else {
          that.getTypeList(2,'article');
          that.addObj.material_label_two = '';
          that.value2 = '';
          that.addObj.material_label_three = '';
          that.value3 = '';
          that.articleOneList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_one = item.title
            }
          });
          
        }
      } else if(type == 2){
        if(topic == 'topic'){
          that.getTypeList(3,'topic')
          that.topicTwoList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_two = item.title
            }
          });
          that.addObj.topic[num].topic_label_three = '';
          that.topicValue3 = '';
        } else {
          that.getTypeList(3,'article')
          that.articleTwoList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_two = item.title
            }
          });
          that.addObj.material_label_three = '';
          that.value3 = '';
        }
      } else if(type == 3){
        if(topic == 'topic'){
          that.topicThreeList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_three = item.title
            }
          });
        } else {
          that.articleThreeList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_three = item.title
            }
          });
        }
      }
    },

    addTopic(){
      var list = {
        topic:'',
        topic_type:'',
        answer:'',
        topic_label_one:'',
        topic_label_two:'',
        topic_label_three:'',
      }
      this.addObj.topic.push(list);
      this.topicValue1 = '';
      this.topicValue2 = '';
      this.topicValue3 = '';
    },

    removeTopic(e,i){
      this.addObj.topic.splice(i,1)
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 11 );
    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出范围的内容 */
    text-overflow: ellipsis; /* 使用省略号 */
    padding: 21px 5px;
  }

  /* .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 10px;
  } */

  .add-title,
  .list-title{
    color: #333333;
    font-size: 22px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
    line-height: 40px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.btn-ai{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 39px;
  line-height: 39px;
  display: inline-block;
  margin-left: 20px;
}

.ai-msg{
  height: 50px;
  line-height: 50px;
  color: #777777;
  font-size: 14px;
  display: inline-block;
  margin-left: 18px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}


.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-add,
.topic-title .btn-remove{
  font-size: 18px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.topic-title .btn-remove{
  margin-left: 40px;
  background-color: transparent;
  color: #6098F2;
  border: solid 1px #6098F2;
}

.topic-title .btn-add{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 20px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.btn-topic-add{
  font-size: 18px;
  color: #6098F2;
  margin: 30px 0 20px;
  display: block;  
  border: solid 1px #6098F2;
  border-radius: 6px;
  padding: 3px 30px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/question/index.vue